
import Vue from 'vue'
import { signOut } from '@/services/entraAuth'

import JcdcErrorNetworkIssue from '@/components/jcdc/JcdcErrorNetworkIssue.vue'
import JcdcErrorAccessDenied from '@/components/jcdc/JcdcErrorAccessDenied.vue'

export default Vue.extend({
  name: 'JcdcErrorWrapper',
  components: { JcdcErrorNetworkIssue, JcdcErrorAccessDenied },
  props: {},
  data() {
    return {
      customMessage:
        'If the error persists, please contact your instructor or center staff for assistance. If they cannot find a solution, ask them to contact the center POC or the TAC with the following information:',
    }
  },
  computed: {
    noAccess(): boolean {
      // Only needed in Apps that use Entra login, otherwise errors should be returned on the login screen
      // Tell the component which API failures should trigger the noAccess action. For example...
      return this.$store.state.networkError.response?.status < 500
    },
  },
  methods: {
    entraSignOut() {
      signOut()
    },
  },
})
